import { COLORS } from "./styles";
import WieldyLogo from "./WieldyLogo";

const shimmer = "maintenance-skeleton-shimmer";

function Bar({
  width,
  height,
  light = false,
  radius = 8,
}: {
  width: number | string;
  height: number;
  light?: boolean;
  radius?: number;
}) {
  return (
    <div
      style={{
        width,
        height,
        background: light ? COLORS.skeletonLight : COLORS.skeleton,
        borderRadius: radius,
      }}
    />
  );
}

export default function LoadingSkeleton() {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        background: COLORS.bg,
      }}
    >
      <style>{`
        @keyframes ${shimmer} {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
      `}</style>
      <WieldyLogo />
      <div
        style={{
          animation: `${shimmer} 1.6s ease-in-out infinite`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 28,
          width: 560,
          background: COLORS.cardBg,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 16,
          padding: "48px 48px 40px 48px",
          boxShadow: "0 8px 32px rgba(10, 11, 15, 0.08)",
        }}
      >
        <Bar width={180} height={24} radius={999} />
        <Bar width={360} height={32} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Bar width={420} height={14} light />
          <Bar width={360} height={14} light />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
            padding: "24px 0 8px 0",
          }}
        >
          <Bar width={260} height={56} radius={12} />
          <Bar width={160} height={12} light />
        </div>
        <Bar width={220} height={14} light />
        <Bar width="100%" height={1} />
        <Bar width={340} height={12} light />
      </div>
    </div>
  );
}
